"use strict";

import { AppDispatcher } from 'Dispatcher';
import { FormSettingsConstants } from "Constants/Forms/FormSettingsConstants";
export function formSettingsInitialize(formObj, _ref) {
  var form = _ref.form,
      popup = _ref.popup;
  AppDispatcher.dispatch({
    actionType: FormSettingsConstants.FORM_SETTINGS_INITIALIZE,
    formObj: formObj,
    formInst: form,
    popupInst: popup
  });
}
export function formSettingsUpdate(_ref2) {
  var nextData = _ref2.nextData,
      UUID = _ref2.UUID;
  AppDispatcher.dispatch({
    actionType: FormSettingsConstants.FORM_SETTINGS_UPDATE,
    nextData: nextData,
    UUID: UUID
  });
}